type MetaConfig = {
  dsn: string;
  environment: string;
  revision: string;
};

const lazyLoadSentry = async () => {
  const init = (await import('@shared/lib/sentry/init')).default;
  const config = document.head.querySelector('meta[name="sentry-config"]')?.getAttribute('content');
  if (!config) {
    return;
  }

  const { dsn, environment, revision } = JSON.parse(atob(config)) as MetaConfig;

  init({
    dsn,
    environment,
    release: revision,
  });
};

export default lazyLoadSentry;
